// extracted by mini-css-extract-plugin
module.exports = {"sponsored_skyscraper_banner":"sponsored_skyscraper_banner--0rbk2"};